module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/core-js/modules/_function-to-string.js
// module id = it4f
// module chunks = 1